import clsx from 'clsx';
import React from 'react';

import Button from '@components/Button';
import IconPlus from '@components/Images/Rebranding/IconPlus';

export enum MenuLinkTypes {
  Button = 'button',
  Link = 'link',
}

interface MenuLinkProps {
  as: MenuLinkTypes;
  href?: string;
  icon?: JSX.Element;
  isMenuOpen?: boolean;
  isPro?: boolean;
  name: string;
  showSeparator?: boolean;
  onClick?: () => void;
  onClickCapture?: () => void;
}

const MenuLink = ({
  as,
  href,
  icon,
  isMenuOpen = false,
  isPro,
  name,
  showSeparator,
  onClick,
  onClickCapture,
}: MenuLinkProps) => {
  return (
    <div className="flex flex-col">
      <Button
        as={as}
        className={clsx(
          'mb-8 flex w-full items-center justify-between border-0 bg-transparent p-0',
          {
            'text-pro-gold': isMenuOpen && isPro,
            'text-primary-magenta': isMenuOpen && !isPro,
            'text-white': !isMenuOpen,
          }
        )}
        onClick={onClick}
        onClickCapture={onClickCapture}
        href={href}
      >
        <span
          className={clsx('font-suisse-intl-mono text-headline-xs font-bold', {
            'border-0 border-b-2 border-solid': isMenuOpen,
            'border-0': !isMenuOpen,
          })}
        >
          {name}
        </span>
        {as === MenuLinkTypes.Button ? (
          <IconPlus
            className={clsx('w-16 stroke-2 transition-all duration-300 ease-in', {
              'rotate-[135deg]': isMenuOpen,
              'rotate-0': !isMenuOpen,
            })}
          />
        ) : icon ? (
          icon
        ) : null}
      </Button>
      {showSeparator && <div className="h-[1px] w-full bg-grayscale-gray"></div>}
    </div>
  );
};

export default MenuLink;
